export const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || '',
};
